import { yupResolver } from "@hookform/resolvers/yup"
import * as yup from "yup"

import type {
	IssueType,
	LogLevel,
	LogMatchMethod,
} from "@/souhl_admin/gql/__generated__/graphql"

const issueTypeValues: IssueType[] = [
	"PROGRAMMING_ISSUE",
	"BIZ_TASK",
	"DEV_TASK",
]

const logLevelValues: LogLevel[] = ["CRITICAL", "ERROR", "WARNING"]

const logMatchMethodValues: LogMatchMethod[] = ["PARTIAL", "REGEX"]

// TODO: ちゃんとみていない

export const logModuleNameValues = [
	"cancy",
	"scraping",
	"nabeko",
	"unknown",
	"soppy",
	"idp",
	"notiffy",
	"long_job_executor",
	"summary",
	"fe_event",
	"debug",
	"unique",
	"nexus",
	"publish_worker",
	"bizdev",
	"accounting",
	"taiga",
] as const

export type LogModuleName = (typeof logModuleNameValues)[number]

export const knownIssueFormSchema = yup.object({
	description: yup
		.string()
		.min(1, "Description は必須です")
		.required("Description は必須です")
		.default(""),
	issueType: yup
		.mixed<IssueType>()
		.oneOf(issueTypeValues)
		.required()
		.default("PROGRAMMING_ISSUE" as IssueType),
	logLevel: yup
		.mixed<LogLevel>()
		.oneOf(logLevelValues)
		.required()
		.default("ERROR" as LogLevel),
	logMatchMethod: yup
		.mixed<LogMatchMethod>()
		.oneOf(logMatchMethodValues)
		.required()
		.default("PARTIAL" as LogMatchMethod),
	logKeyword: yup.string().required("Log Keyword は必須です"),
	logModuleName: yup
		.mixed<LogModuleName>()
		.oneOf([...logModuleNameValues])
		.required("Log Module Name は必須です")
		.default("scraping" as LogModuleName),
	logKind: yup.string().default(""),
	logSalonIds: yup.string().default(""), // カンマ区切りで複数入力
	slackChannelNameToNotify: yup
		.string()
		.required("Slack Channel は必須です")
		.default("02_dev_resolve_incident"),
	mentionTargetIds: yup
		.array()
		.of(yup.string().required())
		.default(["!subteam^S09JKJ82CAW"]),
	thresholdCountToNotify: yup
		.number()
		.min(1, "Threshold Count は 1 以上である必要があります")
		.required()
		.default(10),
	enableCooldown: yup.boolean().default(true),
	cooldownHoursToNotify: yup
		.number()
		.nullable()
		.when("enableCooldown", {
			is: true,
			then: (schema) =>
				schema
					.min(1, "Cooldown Hours は 1 以上である必要があります")
					.required("Cooldown Hours を設定してください"),
			otherwise: (schema) => schema.nullable(),
		})
		.default(1),
	autoResolveDaysAfterLastActivity: yup
		.number()
		.min(1, "Auto Resolve Days は 1 以上である必要があります")
		.required()
		.default(30),
	shouldSendIosCriticalNotification: yup.boolean().default(false),
})

export type KnownIssueFormData = yup.InferType<typeof knownIssueFormSchema>

export const knownIssueFormResolver = yupResolver(knownIssueFormSchema)
